/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useTranslation } from "react-i18next";
import { To, useNavigate } from "react-router-dom";

// component imports
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";

export const BackButton = ({
  to = -1,
}: {
  to?: string | number | To;
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(to as To)
  }

  return (
    <Button
      className="py-0 pl-0 back-button"
      type="link"
      icon={<LeftOutlined />}
      onClick={handleBack}
    >
      {t("common.back")}
    </Button>
  );
};
